<template>
  <b-container>
    <b-row>
      <b-col v-if="RoleID ==2" md="10">
        <form class="mt-3">
          <div class="form-row">
            <!-- <div class="form-group col-md-5">
                      <label for="ipLoanType">Scheme Name</label>
                      <select id="ipLoanType" class="form-control" :options="schemes" v-model="selectedScheme">
                      </select>
            </div>-->
            <div class="form-group col-md-3">
              <b-form-group
                id="fieldset-horizontal"
                label-cols-sm="4"
                label-cols-lg="2"
                label="District"
                label-for="ipDistrict"
                label-size="sm"
              >
                <b-select
                  id="ipDistrict"
                  :options="districts"
                  value-field="DistID"
                  text-field="DistName"
                  required
                  size="sm"
                  :disabled="userDistrict != '00000000-0000-0000-0000-000000000000'"
                  v-model="selectedDistrict"
                  @change.native="onChangeDistrict"
                  class="form-control"
                ></b-select>
              </b-form-group>
            </div>
            <div class="form-group col-md-5"></div>
          </div>
        </form>
        <b-card no-body>
          <b-tabs card>
            <b-tab title="Applications" active>
              <b-row>
                <b-col md="6">
                  <b-table
                    show-empty
                    head-variant="dark"
                    empty-text="No Applications available."
                    stacked="md"
                    bordered
                    striped
                    :busy="isLoading"
                    :items="appsummary"
                    :fields="fields"
                    style="font-size:12px"
                  >
                    <template #table-busy>
                      <div class="text-center text-primary my-2">
                        <b-spinner class="align-middle mr-2"></b-spinner>
                        <strong>Loading...</strong>
                      </div>
                    </template>
                    <template v-slot:cell(TotalIndividual)="row">
                      <b-button
                        size="sm"
                        @click.stop="viewDetailsIR(row.item, 0)"
                        class="mr-1 pt-0 pb-0"
                        variant="link"
                      >{{row.item.TotalIndividual}}</b-button>
                    </template>
                    <template v-slot:cell(TotalGroup)="data">
                      <b-button
                        size="sm"
                        @click.stop="viewDetailsGR(data.item)"
                        class="mr-1 pt-0 pb-0"
                        variant="link"
                        v-b-tooltip.hover
                        title="View Details"
                      >{{data.item.TotalGroup}}</b-button>
                    </template>
                      <template v-slot:cell(TotalEducation)="data">
                      <b-button
                        size="sm"
                        @click.stop="viewDetailsEducation(data.item)"
                        class="mr-1 pt-0 pb-0"
                        variant="link"
                        v-b-tooltip.hover
                        title="View Details"
                      >{{data.item.TotalEducation}}</b-button>
                    </template>
                  </b-table>
                </b-col>
              </b-row>
            </b-tab>
            <b-tab title="Claims">
              <b-col md="10">
                <b-form-radio-group
                  id="radio-group-claimloantype-dm"
                  v-model="claimloantype"
                  @change.native="onClaimLoanTypeChange"
                  name="radio-claimloan-type-dm"
                >
                  <b-form-radio value="0">All</b-form-radio>
                  <b-form-radio value="1">Individual Loan</b-form-radio>
                  <b-form-radio value="2">Group Loan</b-form-radio>
                </b-form-radio-group>
              </b-col>
              <b-col md="8">
                <claims-table-dm :districtId="selectedDistrict" @ttl="setClaims"></claims-table-dm>
              </b-col>
            </b-tab>
          </b-tabs>
        </b-card>
      </b-col>
      <b-col class="mt-2">
        <b-card v-if="RoleID ==3 || RoleID ==4 || RoleID ==5 || RoleID==10" md="10" no-body>
          <b-tabs card>
            <b-tab title="Applications">
              <b-row>
                <b-col md="10">
                  <b-form-radio-group
                    id="radio-group-loantype"
                    v-model="loanType"
                    @change.native="onLoanTypeChange"
                    name="radio-loan-type"
                  >
                    <b-form-radio value="0">All</b-form-radio>
                    <b-form-radio value="1">Individual Loan</b-form-radio>
                    <b-form-radio value="2">Group Loan</b-form-radio>
                    <!-- <b-form-radio value="3">Education Loan</b-form-radio> -->
                  </b-form-radio-group>
                </b-col>
                <b-col>
                  <b-button
                    size="sm"
                    class="mb-2 float-right"
                    variant="primary"
                    @click="doit('xlsx')"
                  >Excel</b-button>
                </b-col>
              </b-row>
              <b-table
                id="data-table"
                show-empty
                head-variant="dark"
                empty-text="No Applications available."
                stacked="md"
                bordered
                striped
                small
                sticky-header="200px"
                :busy="isLoading"
                :items="appsummary"
                :fields="fieldsMD"
                style="font-size:12px"
              >
                <template #table-busy>
                  <div class="text-center text-primary my-2">
                    <b-spinner class="align-middle mr-2"></b-spinner>
                    <strong>Loading...</strong>
                  </div>
                </template>
                <template v-slot:thead-top>
                  <b-tr>
                    <b-th colspan="2">
                      <span class="sr-only"></span>
                    </b-th>
                    <b-th variant="secondary" colspan="6">Pending with Corporation</b-th>
                    <b-th variant="primary" colspan="4">Pending with Applicant</b-th>
                    <b-th variant="danger" colspan="2">
                      <span class="sr-only"></span>
                    </b-th>
                  </b-tr>
                </template>

                <template v-slot:cell(DM)="data">
                  <b-button
                    size="sm"
                    @click.stop="viewDetails(data.item, 'DM')"
                    class="mr-1 pt-0 pb-0"
                    variant="link"
                  >{{data.item.DM}}</b-button>
                </template>

                <template v-slot:cell(DBSC)="data">
                  <b-button
                    size="sm"
                    @click.stop="viewDetails(data.item, 'DBSC')"
                    class="mr-1 pt-0 pb-0"
                    variant="link"
                  >{{data.item.DBSC}}</b-button>
                </template>

                <template v-slot:cell(Project)="data">
                  <b-button
                    size="sm"
                    @click.stop="viewDetails(data.item, 'Project')"
                    class="mr-1 pt-0 pb-0"
                    variant="link"
                  >{{data.item.Project}}</b-button>
                </template>

               <template v-slot:cell(DGM)="data">
                  <b-button
                    size="sm  "
                    @click.stop="viewDetails(data.item, 'DGM')"
                    class="mr-1 pt-0 pb-0"
                    variant="link"
                  >{{data.item.DGM}}</b-button>
                </template>

                <template v-slot:cell(GM)="data">
                  <b-button
                    size="sm"
                    @click.stop="viewDetails(data.item, 'GM')"
                    class="mr-1 pt-0 pb-0"
                    variant="link"
                  >{{data.item.GM}}</b-button>
                </template>

                <!-- <template v-slot:cell(MD)="data">
                  <b-button
                    size="sm"
                    @click.stop="viewDetails(data.item, 'MD')"
                    class="mr-1 pt-0 pb-0"
                    variant="link"
                  >{{data.item.MD}}</b-button>
                </template> -->

                <template v-slot:cell(LOI)="data">
                  <b-button
                    size="sm"
                    @click.stop="viewDetails(data.item, 'LOI')"
                    class="mr-1 pt-0 pb-0"
                    variant="link"
                  >{{data.item.LOI}}</b-button>
                </template>

                <template v-slot:cell(Lapsed)="data">
                  <b-button
                    size="sm"
                    @click.stop="viewDetails(data.item, 'Lapsed')"
                    class="mr-1 pt-0 pb-0"
                    variant="link"
                  >{{data.item.Lapsed}}</b-button>
                </template>

                <template v-slot:cell(Disbursed)="data">
                  <b-button
                    size="sm"
                    @click.stop="viewDetails(data.item, 'Disbursed')"
                    class="mr-1 pt-0 pb-0"
                    variant="link"
                  >{{data.item.Disbursed}}</b-button>
                </template>

                <template v-slot:cell(Hold)="data">
                  <b-button
                    size="sm"
                    @click.stop="viewDetails(data.item, 'Hold')"
                    class="mr-1 pt-0 pb-0"
                    variant="link"
                  >{{data.item.Hold}}</b-button>
                </template>

                <template v-slot:cell(Rejected)="data">
                  <b-button
                    size="sm"
                    @click.stop="viewDetails(data.item, 'Rejected')"
                    class="mr-1 pt-0 pb-0"
                    variant="link"
                  >{{data.item.Rejected}}</b-button>
                </template>

                <template v-slot:cell(Total)="data">
                  <b-button
                    size="sm"
                    @click.stop="viewDetails(data.item, 'Total')"
                    class="mr-1 pt-0 pb-0"
                    variant="link"
                  >{{data.item.Total}}</b-button>
                </template>
              </b-table>
            </b-tab>
            <b-tab title="Claims">
              <b-col md="10">
                <b-form-radio-group
                  id="radio-group-claimloantype"
                  v-model="claimloantype"
                  @change.native="onClaimLoanTypeChange"
                  name="radio-claimloan-type"
                >
                  <b-form-radio value="0">All</b-form-radio>
                  <b-form-radio value="1">Individual Loan</b-form-radio>
                  <b-form-radio value="2">Group Loan</b-form-radio>
                  <!-- <b-form-radio value="3">Education Loan</b-form-radio> -->
                </b-form-radio-group>
              </b-col>
              <b-col md="8">
                <claims-table @ttl="setClaims"></claims-table>
              </b-col>
            </b-tab>
          </b-tabs>
        </b-card>
        <b-col v-if="RoleID ==6 || RoleID ==7" md="10">
          <b-col md="10">
            <b-form-radio-group
              id="radio-group-claimloantype"
              v-model="claimloantype"
              @change.native="onClaimLoanTypeChange"
              name="radio-claimloan-type"
            >
              <b-form-radio value="0">All</b-form-radio>
              <b-form-radio value="1">Individual Loan</b-form-radio>
              <b-form-radio value="2">Group Loan</b-form-radio>
              <!-- <b-form-radio value="3">Education Loan</b-form-radio> -->
            </b-form-radio-group>
          </b-col>
          <claims-table @ttl="setClaims"></claims-table>
        </b-col>
      </b-col>
      <b-col md="2">
        <b-card
          border-variant="primary"
          class="shadow rounded mt-3"
          header-border-variant="secondary"
          v-if="RoleID ==3 || RoleID ==4 || RoleID ==5 || RoleID ==10"
          align="center"
        >
          <a href="#" @click="viewDBDetails">
            <h3 class="my-2">{{PendingCountLOI}}</h3>
            <p class="mb-3">{{PendingLabel}}</p>
          </a>
        </b-card>
        <br />
        <b-card
          border-variant="danger"
          class="shadow rounded"
          header-border-variant="secondary"
          v-if="RoleID ==6 || RoleID ==4 || RoleID ==5 || RoleID ==7"
          align="center"
        >
          <a href="#" @click="viewClaims">
            <h3 class="my-2">{{PendingCountClaim}}</h3>
            <p class="mb-3">Pending Claims Approval</p>
          </a>
        </b-card>
        <br />
        <b-card
          border-variant="warning"
          class="shadow rounded"
          header-border-variant="secondary"
          align="center"
        >
          <a href="#" @click="viewClaims">
            <h3 class="my-2">{{PendingClaimApplications}}</h3>
            <p class="mb-3">Pending Claim Applications</p>
          </a>
        </b-card>
        <br />
        <b-card
          border-variant="success"
          class="shadow rounded"
          header-border-variant="secondary"
          align="center"
        >
          <a href="#" @click="viewClaims">
            <h3 class="my-2">{{PaidClaimAmount}}</h3>
            <p class="mb-3">Paid Claim Amount</p>
          </a>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import apis from "@/apis";
import * as _ from "lodash";
import Spinner from "vue-simple-spinner";
import ClaimsTable from "@/components/Admin/ClaimsTable";
import ClaimsTableDM from "@/components/Admin/ClaimsTableDM";
import XLSX from "xlsx";
export default {
  components: {
    Spinner,
    ClaimsTable,
    'claims-table-dm': ClaimsTableDM
  },
  data() {
    return {
      RoleID: 2,
      districts: [],
      appsummary: [],
      appsummaryMD: [],
      schemes: [],
      fields: [
        { key: "ApplicationStatus", label: "Application Status" },
        { key: "TotalIndividual", label: "Individual" },
        { key: "TotalGroup", label: "Group" },
        //  { key: "TotalEducation", label: "Education" },
        { key: "PendingAt", label: "Pending At" }
      ],
      fieldsMD: [
        { key: "SL", label: "SL" },
        { key: "DistrictName", label: "District Name" },
        { key: "DM", label: "DM" },
        { key: "DBSC", label: "DBSC" },
        { key: "Project", label: "RM" },
        { key: "DGM", label: "PM" },
        { key: "GM", label: "GM" },
        { key: "LOI", label: "LOI" },
        { key: "Lapsed", label: "Lapsed" },
        { key: "Disbursed", label: "Disbursed" },
        { key: "Hold", label: "Hold" },
        { key: "Rejected", label: "Rejected" },
        { key: "Total", label: "Total" },
        { Key: "Registrations", label: "Registrations" }
      ],
      selectedDistrict: "00000000-0000-0000-0000-000000000000",
      selectedScheme: "00000000-0000-0000-0000-000000000000",
      PendingCountClaim: 0,
      PendingClaimApplications: 0,
      PaidClaimAmount: 0,
      PendingCountLOI: 0,
      PendingLabel: "Pending MD Approvals",
      loanType: 0,
      claimloantype:0,
      isLoading: true
    };
  },
  computed: {
    userDistrict() {
      return this.$store.getters.getUserDistrict;
    }
  },
  methods: {
    doit(type, fn, dl) {
      var elt = document.getElementById("data-table").cloneNode(true);
      //Create a HTML Table element.
      var table = document.createElement("TABLE");
      table.border = "1";

      //Add the header row.
      var row = table.insertRow(-1);
      let headerCell = document.createElement("TH");
      headerCell.innerHTML =
        "वसंतराव नाईक विमुक्त जाती व भटक्या जमाती विकास महामंडळ (मर्यादित)";
      // headerCell.append("<p>वैयक्तिक कर्ज व्याज परतावा</p>");
      headerCell.colSpan = 13;
      headerCell.style.textAlign = "center";
      row.appendChild(headerCell);

      var row2 = table.insertRow(-1);
      let headerCell2 = document.createElement("TH");
      if (this.loanType == 1) {
        headerCell2.innerHTML = " कर्ज व्याज परतावा योजना प्रकरणांचा तपशील";
      } else if (this.loanType == 2) {
        headerCell2.innerHTML = "गट कर्ज व्याज परतावा योजना प्रकरणांचा तपशील";
      } else {
        headerCell2.innerHTML =
          "वैयक्तिक व गट कर्ज व्याज परतावा योजना, प्रकरणांचा तपशील";
      }

      headerCell2.colSpan = 8;
      headerCell2.style.textAlign = "center";
      row2.appendChild(headerCell2);

      let headerCell3 = document.createElement("TH");

      var n = new Date();
      headerCell3.innerHTML = n.toLocaleString("hi-IN");

      var x = elt.querySelectorAll("tr");
      headerCell3.style.textAlign = "right";
      headerCell3.colSpan = 5;
      row2.appendChild(headerCell3);

      var i;
      for (i = 0; i < x.length; i++) {
        table.appendChild(x[i]);
      }

      fn =
        "ApplicationSummary_" +
        n
          .toLocaleString("tr-TR")
          .replace(".", "")
          .replace(".", "")
          .replace(" ", "")
          .replace(":", "")
          .replace(":", "") +
        ".xlsx";
      var wb = XLSX.utils.table_to_book(table, {
        sheet: "Application_Summary"
      });
      return dl
        ? XLSX.write(wb, { bookType: type, bookSST: true, type: "base64" })
        : XLSX.writeFile(wb, fn || "ApplicationSummary." + (type || "xlsx"));
    },
    getDistricts(stateid) {
      let promise = apis.getDistricts(stateid);

      promise
        .then(response => {
          if (response.status == 200) {
            this.districts = response.body;
            this.districts.unshift({
              DistID: "00000000-0000-0000-0000-000000000000",
              DistName: "All"
            });
            this.selectedDistrict = this.$store.getters.getUserDistrict;

            this.isLoading = false;
            //this.$router.push("/");
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
    },
    onChangeDistrict(evt) {
      this.selectedDistrict = evt.target.value;
      this.getSummary();
    },
    onLoanTypeChange() {
      this.getSummary();
    },
    onClaimLoanTypeChange() {

     this.$root.$emit('component1',{temploanType:this.claimloantype}); //like this
    },
    getSummary() {
      //let userDistrict = this.$store.getters.getUserDistrict;

      if (this.userDistrict != "00000000-0000-0000-0000-000000000000") {
        this.selectedDistrict = this.userDistrict;
      }
      //this.RoleID = this.$store.getters.loggedUser.RoleID;

      this.isLoading = true;
      var promise;
      if (this.RoleID !== 3 && this.RoleID != 4 && this.RoleID != 5 && this.RoleID!=10) {
        promise = apis.getApplicationSummary(this.selectedDistrict);
      } else if (this.RoleID == 4 || this.RoleID == 5 || this.RoleID==10) {
        promise = apis.getApplicationSummaryMD(this.loanType);
      } else if (this.RoleID == 3) {
        promise = apis.getApplicationSummaryRM(this.Userid);
      } else {
        return;
      }

      promise
        .then(response => {
          if (response.status == 200) {
            this.appsummary = response.body;

            if (this.RoleID == 4) {
              let ttl = _.filter(this.appsummary, { DistrictName: "TOTAL" });
              if (ttl && ttl.length > 0) { this.PendingCountLOI = ttl[0].MD; }
              this.PendingLabel = "Pending MD Approval";
            } else if (this.RoleID == 5) {
              let ttl = _.filter(this.appsummary, { DistrictName: "TOTAL" });
              if (ttl && ttl.length > 0) { this.PendingCountLOI = ttl[0].GM; }
              this.PendingLabel = "Pending GM Approval";
            } else if (this.RoleID == 3) {
              let ttl = _.filter(this.appsummary, { DistrictName: "TOTAL" });
              if (ttl && ttl.length > 0) { this.PendingCountLOI = ttl[0].Project; }
              this.PendingLabel = "Pending RM Approval";
            } else if (this.RoleID == 10) {
              let ttl = _.filter(this.appsummary, { DistrictName: "TOTAL" });
              if (ttl && ttl.length > 0) { this.PendingCountLOI = ttl[0].DGM; }
              this.PendingLabel = "Pending PM Approval";
            }
            this.isLoading = false;
            //this.$router.push("/");
          } else {
            this.alertText = response.body;
            this.isLoading = false;
            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
        })
        .catch(err => {
          this.isLoading = false;
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
    },
    viewDBDetails() {
      let sts = 4;
      if (this.RoleID == 4) {
        sts = 16;
      } else if (this.RoleID == 3) {
        sts = 13;
      }
      this.$store.dispatch(
        "setDistrict",
        "00000000-0000-0000-0000-000000000000"
      );
      this.$store.dispatch("setAppStatus", sts);
      this.$store.dispatch("setLoanType", 1);

      this.$router.push({
        name: "Applications",
        params: {
          userDistrictID: "00000000-0000-0000-0000-000000000000",
          userApprovalStatus: sts,
          userLoanType: 1
        }
      });
    },
    viewClaims(item, sts) {
      this.$store.dispatch("setDistrict", "00000000-0000-0000-0000-000000000000");
      this.$store.dispatch("setAppStatus", 0);
      switch (this.RoleID) {
        case 6:
          this.$store.dispatch("setStatusOwner", "Accounts");
          break;
        case 5:
          this.$store.dispatch("setStatusOwner", "GM");
          break;
        case 4:
          this.$store.dispatch("setStatusOwner", "MD");
          break;
        case 7:
          this.$store.dispatch("setStatusOwner", "Auditor");
          break;
      }
      this.$store.dispatch("setLoanType", 1);
      this.$router.push("/approveclaims");
    },
    viewDetails(item, type) {
      let sts = 1;
      this.$store.dispatch("setDistrict", item.DistrictID);
      switch (type) {
        case "DM":
          sts = -1;   // -1 = all DM-queue statuses (Pending + Returned by GM/PM)
          break;
        case "DBSC":
          sts = 2;
          break;
        case "Project":
          sts = 13;
          break;
        case "DGM":
          sts = 4;
          break;
        case "GM":
          sts = 30;
          break;
        case "MD":
          sts = 16;
          break;
        case "LOI":
          sts = -2;   // -2 = all LOI-generated statuses (6,8,9,10,11,16,23-29)
          break;
        case "Lapsed":
          sts = 8;
          break;
        case "Disbursed":
          sts = 22;
          break;
        case "Hold":
          sts = 3;
          break;
        case "Rejected":
          sts = 18;
          break;
        case "Total":
          sts = 16;
          break;
      }
      this.$store.dispatch("setAppStatus", sts);
      this.$store.dispatch("setLoanType", 1);
      this.$store.dispatch("setSearchForm", {});
      if(this.loanType==0)
      this.loanType=1;
      this.$router.push({
        name: "Applications",
        params: {
          userDistrictID: item.DistrictID,
          userApprovalStatus: sts,
          userLoanType: this.loanType
        }
      });
    },

    viewDetailsIR(item, index) {
      if (item.Id > 0) {
        this.$store.dispatch("setDistrict", this.selectedDistrict);
        this.$store.dispatch("setAppStatus", item.Id);
        this.$store.dispatch("setLoanType", 1);
        this.$store.dispatch("setSearchForm", {});
        this.$router.push({
          name: "Applications",
          params: {
            userDistrictID: this.selectedDistrict,
            userApprovalStatus: item.Id,
            userLoanType: 1
          }
        });
      }
    },
    viewDetailsGR(item) {
      this.$store.dispatch("setDistrict", this.selectedDistrict);
      this.$store.dispatch("setAppStatus", item.Id);
      this.$store.dispatch("setLoanType", 2);
      this.$store.dispatch("setSearchForm", {});
      this.$router.push({
          name: "Applications",
          params: {
            userDistrictID: this.selectedDistrict,
            userApprovalStatus: item.Id,
            userLoanType: 2
          }
        });
    },
    viewDetailsEducation(item) {
      this.$store.dispatch("setDistrict", this.selectedDistrict);
      this.$store.dispatch("setAppStatus", item.Id);
      this.$store.dispatch("setLoanType", 2);
      this.$store.dispatch("setSearchForm", {});
      this.$router.push({
          name: "Applications",
          params: {
            userDistrictID: this.selectedDistrict,
            userApprovalStatus: item.Id,
            userLoanType: 3
          }
        });
    },
    setClaims(accounts, dgm, gm, md, pendingApplications, paidAmount) {
      this.PendingClaimApplications = pendingApplications || 0;
      this.PaidClaimAmount = paidAmount || 0;
      switch (this.RoleID) {

        case 6:
          this.PendingCountClaim = accounts;
          break;
        case 5:
          this.PendingCountClaim = gm;
          break;
        case 4:
          this.PendingCountClaim = md;
          break;
      }
    }
  },
  mounted() {
    this.getDistricts("BB62F7B0-748D-4E64-AD4F-8EF691431FA1");
    this.RoleID = this.$store.getters.loggedUser.RoleID;
    this.Userid= this.$store.getters.loggedUser.UserId;
   console.log();
    if (this.RoleID != 6) {
      this.getSummary();
    }
  }
};
</script>

<style>
</style>






// WEBPACK FOOTER //
// src/components/Admin/AdminDashboard.vue